// extracted by mini-css-extract-plugin
module.exports = {"wrap":"wrap_2ycEh","issueButton":"issueButton_3LJV2","hidingIssueButton":"hidingIssueButton_3q4FD issueButton_3LJV2"};